import FlavourPickerCarousel from './FlavourPickerCarousel';
const els = document.querySelectorAll('.fp');

for (let el of els) {
    FlavourPickerCarousel(el);
}
